import {ApiBase, InternationalizedField} from "@/api/common";
import config from "@/config";
import ExtraPhoneme from "@/api/extra-phoneme";
import Phoneme from "@/api/phoneme";

const NO_UPLOAD_FIELDS = [
    'audio_link',
    'phoneme_objects',
];

export default class ExtraLine extends ApiBase<ExtraLine> {
    public static readonly SLUG: string = 'extra-line';
    private static readonly URL_BASE: string = config.API_ROOT + '/extra-line/';

    public id?: number = undefined;
    public audio_path?: number = undefined;
    public audio_link?: string = undefined;
    public audio_file?: File|null = undefined;
    public sentence?: string = undefined;
    public sentence_i18n: InternationalizedField<string> = new InternationalizedField<string>();
    public state?: string = 'created';
    public parent_id?: number = undefined;
    public parent_model?: string = undefined;
    public start_time?: number = undefined;
    public end_time?: number = undefined;
    public phonemes?: number[] = undefined;
    public phoneme_objects: ExtraPhoneme[] = [];
    public transcription?: string = undefined;


    public constructor() {
        super({
            urlBase: ExtraLine.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }

    public assign(response: any): ExtraLine {
        super.assign(response);
        if (response) {
            if ('sentence_i18n' in response) {
                this.sentence_i18n = new InternationalizedField<string>(response.sentence_i18n);
            }
            if ('phonemes' in response) {
                this.phonemes = undefined;
                if (response.phonemes) {
                    response.phonemes.forEach((phoneme: any) => {
                        this.phoneme_objects.push(new Phoneme().assign(phoneme));
                    });
                }
            }
        }
        this.state = 'unchanged';
        return this;
    }

    public async save(): Promise<number> {
        if (!this.id) {
            return await super.save();
        } else {
            await Promise.all([
                this.savePhonemes(),
            ]);
            return await super.save();
        }
    }

    public async delete(): Promise<void> {
        return super.delete();
    }

    public async savePhonemes() {
        for (const phoneme of this.phoneme_objects) {
            if (phoneme.state === 'updated') {
                phoneme.parent = this.id;
                if (!this.phonemes) {
                    this.phonemes = [];
                }
                this.phonemes.push(await phoneme.save());
            } else if (phoneme.state === 'deleted' && phoneme.id) {
                await phoneme.delete();
            }
        }
    }

}